<loader></loader>

<ngx-loading-bar
    *ngIf="loadingRouteConfig"
    [includeSpinner]="false"
    [color]="primaryColor"
></ngx-loading-bar>

<in-back-to-app-bar></in-back-to-app-bar>

<router-outlet></router-outlet>
